import * as React from 'react'
import { GlobalContext } from 'components/Store'
import SanityBlock from 'components/common/SanityBlock'
import ProjectsLegend from './ProjectsLegend'
import Map from 'components/map/Map'
import Marker from 'components/map/Marker'
import ProjectsList from './ProjectsList'

export default function InteractiveMap({ _rawContent }) {
	const { projects, projectTypes, $filteredType } =
		React.useContext(GlobalContext)

	const filteredProjects = projects?.filter(
		({ type: [t] }) => !$filteredType || t.name === $filteredType,
	)

	return (
		<section id="map" className="mx-auto max-w-screen-xl space-y-12 px-4 py-16">
			<header className="richtext [&_h2]:h0 max-w-[550px]">
				<SanityBlock className="mt-8" body={_rawContent} />
			</header>

			<article className="grid gap-8 md:grid-cols-[2fr,1fr] md:grid-rows-[auto,30em]">
				<ProjectsLegend projectTypes={projectTypes} />

				<Map className="overflow-hidden <md:aspect-square">
					{filteredProjects?.map(({ location, ...project }, key) => (
						<Marker {...project} {...location} key={key} />
					))}
				</Map>

				<ProjectsList projects={filteredProjects} />
			</article>
		</section>
	)
}
